export default "__VITE_ASSET__B59Eui5X__"